<template>
  <div>
  </div>
</template>
<script>
import qs from "query-string";

export default {
  data() {
    return {
      
    };
  },
  mounted() {
    let { rd } = qs.parse(location.search);
    if (rd){
		this.$http.post('/member/login_token').then(function(data){
			const rdarray = rd.split(/#/);
			const qeury = rdarray[rdarray.length-1];
			if (qeury.indexOf('?')>-1){
				rd += '&token='+ data.result;
			}
			else{
				rd += '?token='+ data.result;
			}
			window.location = rd;
		})
	}
  }
};
</script>